import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, X, Wrench, ShoppingCart, Smartphone, ArrowUpFromLine, Zap } from "lucide-react";
import { toast } from "sonner";
import CreateOSModal from "@/components/CreateOSModal";
import { useAuth } from "@/context/AuthContext";

const actions = [
  { key: "os", label: "Nova Ordem de Serviço", icon: Wrench, perm: "service_orders.create" },
  { key: "venda", label: "Venda Rápida", icon: ShoppingCart, perm: "finance.manage" },
  { key: "compra", label: "Compra de Celular", icon: Smartphone, perm: "inventory.manage" },
  { key: "saida", label: "Nova Saída", icon: ArrowUpFromLine, perm: "finance.manage" },
  { key: "express", label: "Alpha Express", icon: Zap, perm: "dashboard.view" },
];

export default function AlphaFab() {
  const [open, setOpen] = useState(false);
  const [osOpen, setOsOpen] = useState(false);
  const { hasPerm } = useAuth();
  const navigate = useNavigate();

  const handle = (key) => {
    setOpen(false);
    if (key === "os") setOsOpen(true);
    else if (key === "venda") navigate("/app/pdv");
    else toast("Em breve", { description: "Este módulo entra numa próxima evolução v1.x." });
  };

  const visible = actions.filter((a) => hasPerm(a.perm));

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50 no-print flex flex-col items-end gap-3">
        <AnimatePresence>
          {open &&
            visible.map((a, i) => (
              <motion.button
                key={a.key}
                data-testid={`fab-action-${a.key}`}
                initial={{ opacity: 0, y: 12, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 12, scale: 0.9 }}
                transition={{ duration: 0.15, delay: i * 0.03 }}
                onClick={() => handle(a.key)}
                className="flex items-center gap-3 rounded-full bg-[#1A1A22] border border-gold/30 pl-4 pr-2 py-2 text-sm font-medium text-white hover:border-gold/60 transition-colors"
              >
                <span>{a.label}</span>
                <span className="h-8 w-8 rounded-full bg-gold/15 flex items-center justify-center">
                  <a.icon size={16} className="text-gold-bright" />
                </span>
              </motion.button>
            ))}
        </AnimatePresence>
        <motion.button
          data-testid="floating-alpha-button"
          whileTap={{ scale: 0.94 }}
          whileHover={{ scale: 1.05 }}
          onClick={() => setOpen((o) => !o)}
          className="h-16 w-16 rounded-full flex items-center justify-center text-black font-bold shadow-[0_0_25px_rgba(212,175,55,0.45)]"
          style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}
        >
          {open ? <X size={26} /> : <Plus size={28} />}
        </motion.button>
      </div>
      <CreateOSModal open={osOpen} onClose={() => setOsOpen(false)} />
    </>
  );
}
